var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tooltip',_vm._g(_vm._b({},'a-tooltip',_vm.$attrs,false),_vm.$listeners),[_c('template',{slot:"title"},[_vm._t("title")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }